import {removeDuplicates, sortByKey} from 'presentation/utils';

import {FlowEnum} from '../../../constants';
import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';

export const formatExamUnit = (
	units: Units<FlowEnum.EXAM>[],
	sortUnitsBy: keyof Units<FlowEnum.EXAM>,
) => {
	const filterDuplicate = removeDuplicates(units);
	const sortedUnitsByName = filterDuplicate && sortByKey(filterDuplicate, sortUnitsBy);

	return sortedUnitsByName;
};
